import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-white py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          Privacy Policy
        </h1>
        {/* <p className="mt-4 text-lg text-gray-600">
          Effective Date: {new Date().toLocaleDateString()}
        </p> */}
      </div>

      <div className="prose prose-lg mx-auto">
        <p>
          This privacy policy is relevant to the website and all products and services provided by
          Envipro Solutions Pty Ltd. We are committed to safeguarding your data and will refrain
          from collecting any information that falls outside the boundaries of reasonable use.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">Your Consent</h2>
        <p>
          Your use of our website signifies your agreement to our privacy policy.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">Terms and Conditions</h2>
        <p>
          To understand the regulations, disclaimers, and limitations of liability that apply to the
          use of our website, please refer to the Terms and Conditions section.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">Purpose of Collection</h2>
        <p>
          The primary purpose of collecting your personal information is to facilitate the provision
          of products or services to you. Additionally, this information may be utilized to promote
          or market associated products or services that may be of interest to you.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">What Information Do We Collect?</h2>
        <p>
          We may gather personal identification information from users through various methods,
          which include, but are not limited to, instances when users access our website,
          participate in surveys, complete forms, and engage in other activities, services, features,
          or resources that we provide on our site. During the process of ordering or registering on
          our site, you may be prompted to provide details such as your name, email address,
          mailing address, and phone number. Nonetheless, users have the option to browse our
          site anonymously.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">The Category of Information Gathered</h2>
        <p>
          The personal data that we gather encompasses:
        </p>
        <p>
          The information required includes your name, Australian Company Number (ACN) or
          Australian Business Number (ABN), residential address, contact information, and date of
          birth. Additionally, it encompasses payment information, details pertaining to your
          financial institution accounts, credit card information, and documentation of products
          or services provided to or received from you. Furthermore, it includes images captured
          from service locations and geographical location data.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">How Do We Protect Your Information?</h2>
        <p>
          We implement a comprehensive range of security protocols to ensure the protection of
          your personal information when you place an order or provide, submit, or access your
          personal details.
        </p>
        <p>
          Our secure payment processing system guarantees that all sensitive or credit information
          is never stored on our servers; instead, it is managed by a dedicated department. All data
          is encrypted and stored exclusively within our Merchant partners' databases, accessible
          only to individuals with special access rights who are obligated to maintain
          confidentiality regarding this information.
        </p>
        <p>
          Following a transaction, your private information, including credit card details, social
          security numbers, and financial data, will not be retained on our servers unless explicitly
          requested or deemed necessary.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">Disclosure to Others</h2>
        <p>
          While delivering our products or services, your personal information may be shared with
          the following entities:
        </p>
        <p>
          Government entities, regulatory bodies, and other organizations, as mandated or
          permitted by law, may have access to your information. You retain the right to revoke your
          consent for the sharing of your personal information by notifying us in writing at any time.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">Australia Privacy Act 1988 Compliance</h2>
        <p>
          We do not engage in the sale, trade, or transfer of your personally identifiable information
          to external entities. This policy does not extend to trusted third parties who assist us in
          managing our website, conducting our business operations, or providing services to you,
          provided that these parties commit to maintaining the confidentiality of this information.
        </p>
        <p>
          Additionally, we may disclose your information when we deem it necessary to comply
          with legal obligations, enforce our site policies, or safeguard our rights, property, or the
          safety of others.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">Changes to Our Privacy Policy</h2>
        <p>
          If we choose to amend our privacy policy, we will update this page to reflect those
          modifications.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;